<template>
  <div>
    <ts-table-filter
      :columns="columns"
      :data="resources"
      :loading="loading"
      @search="search"
    >
      <template slot-scope="{ row }" slot="estimated">
        <div style="width: fit-content;" v-if="row.estimate_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.estimate_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.estimate_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actual">
        <div style="width: fit-content;" v-if="row.actual_end_date">
          <Icon type="ios-calendar-outline ts-mr-1" />
          <span>{{ row.actual_start_date }}</span>
          <Icon type="ios-calendar-outline ts-mr-1 ts-ml-2" />
          <span>{{ row.actual_end_date }}</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="actions">
        <div
          class="ts-flex ts-space-x-2 ts-items-center"
          style="width: fit-content;"
        >
          <a
            href="#"
            class="text-primary ts-relative"
            @click.prevent="onShowReport(row)"
            v-tooltip="$t('task.report')"
          >
            <div
              v-if="row.reports_count"
              class="ts-absolute ts-right-0 ts-top-0 ts-mr-2 ts-h-2 ts-w-2 ts-bg-red-600 ts-rounded-full"
            ></div>
            <i class="fas fa-file-signature ts-text-base ts-mr-2"></i>
          </a>
          <a
            href="#"
            class="text-primary"
            @click.prevent="onEdit(row)"
            v-tooltip="$t('edit')"
          >
            <Icon type="ios-create" size="20" />
          </a>
          <a
            href="#"
            class="text-danger"
            v-tooltip="$t('delete')"
            @click="deleteRecord(row)"
            :disabled="row._deleting"
          >
            <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
            <Icon type="ios-trash" size="20" v-else />
          </a>
        </div>
      </template>
    </ts-table-filter>
		      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-i-pagination>
      </div>

    <iModalWrapper v-model="isUpdate" :title="$t('update')">
      <EditForm :edit_data="edit_data" v-if="isUpdate" @close="onCloseModal" />
    </iModalWrapper>
    <iModalWrapper
      v-model="isShowReport"
      :title="$t('task.report')"
      width="50%"
    >
      <ReportOnSubTask
        :edit_data="edit_data"
        v-if="isShowReport"
        @close="onCloseModal"
      />
    </iModalWrapper>
  </div>
</template>
<script>
import iModalWrapper from '../../../components/i-modal-wrapper.vue'
import ReportOnSubTask from './report-on-sub-task.vue'
import EditForm from './edit-sub-task-form.vue'
import { mapKeys, camelCase } from 'lodash'
import { mapActions } from 'vuex'

class Pagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export default {
  name: 'subTaskTableComponent',
  components: {
    iModalWrapper,
    ReportOnSubTask,
    EditForm
  },
  data() {
    return {
      pagination: new Pagination(),
      resources: [],
      loading: false,
      edit_data: {},
      isShowReport: false,
      isUpdate: false,
      isCreateNew: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('task.title'),
          key: 'title',
          keySearch: 'task_actions.title',
          minWidth: 200
        },
        {
          title: this.$t('task.owner'),
          key: 'owner_name',
          keySearch: 'owner_name',
          minWidth: 120
        },
        {
          title: this.$t('task.status'),
          key: 'project_status',
          keySearch: 'project_status',
          minWidth: 120
          // fixed: 'left'
        },
        {
          title: this.$t('task.estimated'),
          slot: 'estimated',
          minWidth: 220
        },
        {
          title: this.$t('task.actual'),
          slot: 'actual',
          minWidth: 220,
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.createdAt'),
          key: 'created_at',
          minWidth: 200,
          className: 'ts-font-robot ts-whitespace-no-wrap'
        },
        {
          title: this.$t('task.createdBy'),
          key: 'created_by_name',
          minWidth: 120
        },
        {
          title: this.$t('task.remark'),
          key: 'remark',
          keySearch: 'remark',
          minWidth: 200
        },
        {
          title: this.$t('actions'),
          slot: 'actions',
          fixed: 'right',
          align: 'left',
          width: 130
        }
      ]
    }
  },
  methods: {
    ...mapActions('projectMgt/subTaskProfile', ['subTaskByProject', 'destroy']),
    search(newValue) {
      this.fetchData({
        filter: {
          search: newValue
        }
      })
    },
    fetchData(attributes = {}) {
      const params = Object.assign(
        {
          page: this.pagination.page,
          perPage: this.pagination.perPage,
          search: this.search
        },
        attributes
      )
      this.loading = true
      this.subTaskByProject({
        id: this.$route.params.id,
        params
      })
        .then(respnse => {
          this.receiveResource(respnse)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    receiveResource(response) {
      this.resources = []
      response.data.forEach(resource => {
        this.resources.push(Object.assign(resource, { _deleting: false }))
      })
      if (response.hasOwnProperty('meta')) {
        this.pagination = new Pagination(
          mapKeys(response.meta, (v, k) => camelCase(k))
        )
      } else {
        let { ...meta } = response
        this.pagination = new Pagination(mapKeys(meta, (v, k) => camelCase(k)))
      }
    },
    deleteRecord(record) {
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.destroy(record.id)
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onCloseModal() {
      this.isCreateNew = false
      this.isUpdate = false
      this.fetchData()
    },
    onShowReport(row) {
      this.isShowReport = true
      this.edit_data = row
    },
    onEdit(record) {
      this.isUpdate = true
      this.edit_data = record
    }
  }
}
</script>
